// node_modules
import React, { FC, useState } from "react";
import TextareaAutosize from "react-textarea-autosize";
import { $enum } from "ts-enum-util";
// styles
import styles from "./createSideNoteReply.module.scss";
// Types
import { TPassSideNotePost, TSideNotePostDTO } from "Types";
// Enums
import { PrivacyLevelEnum } from "Enums";
// Controllers
import { SideNoteControllerSingleton } from "Controllers";
// Components
import { FindestButton } from "Components";

type TCreateSideNoteReplyProps = {
    sideNoteInfo: TPassSideNotePost,
    onDone: () => void,
    onCancel: () => void,
    hasNoComments?: boolean
}

export const CreateSideNoteReply: FC<TCreateSideNoteReplyProps> = ({sideNoteInfo, onCancel, onDone, hasNoComments}: TCreateSideNoteReplyProps) => {
    // State
    const [replyText, setReplyText] = useState("");
    const [privacyLevel, setPrivacyLevel] = useState(PrivacyLevelEnum.Everybody);

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setReplyText(event.target.value);
    };

    const onPost = async() => {
        const newSideNote: TSideNotePostDTO = {
            // State from creating
            privacyLevel: privacyLevel,
            text: replyText, 
            // Passed information
            noteType: sideNoteInfo.noteType,
            isReply: sideNoteInfo.isReply,
            replyToId: sideNoteInfo.replyToId,
            entityType: sideNoteInfo.entityType,
            entityId: sideNoteInfo.entityId
        };
        
        await SideNoteControllerSingleton.createAsync(newSideNote);
        
        onDone();
    };

    const onChangePrivacyLevel = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedPrivacyLevel = $enum(PrivacyLevelEnum).asValueOrThrow(parseInt(event.target.value));
        setPrivacyLevel(selectedPrivacyLevel);
    };

    function privacyLevelToText(currentPrivacyLevel: PrivacyLevelEnum): string {
        switch (currentPrivacyLevel) {
            case PrivacyLevelEnum.Everybody:
                return "My team + Findest";
            case PrivacyLevelEnum.MyCompany:
                return "Only Team";
            case PrivacyLevelEnum.Myself:
                return "Only myself";
            default:
                return "";
        }
    }
    
    return (
        <div className={styles.createSideNoteReplyContainer}>
            <div className={styles.createSideNoteReplyInputContainer}>
                <div className={styles.createSideNoteReplyTextarea}>
                    <TextareaAutosize placeholder="Type your comment here..." className={styles.textArea} 
                        value={replyText} onChange={handleOnChange} />
                </div>
                {!sideNoteInfo.isReply ? 
                    <select value={privacyLevel} onChange={onChangePrivacyLevel}>
                        {
                            $enum(PrivacyLevelEnum).map((enumPrivacyLevel, index) => {
                                return (
                                    <option key={index} value={enumPrivacyLevel}>{privacyLevelToText(enumPrivacyLevel)}</option>
                                );
                            })
                        }
                    </select>
                    : <></> }
            </div>
            <div className={styles.createSideNoteReplyButtonsContainer}>
                <FindestButton id="post-comment-reply-button" extraClassName={styles.postButton} title="Post" onClick={onPost}/>
                {hasNoComments && hasNoComments === true ? 
                    null
                :
                    <FindestButton extraClassName={styles.cancelButton} title="Cancel" onClick={onCancel} />
                }
            </div>
        </div>
    );
};